<template>
    <div class="o-home u-w100 u-py40 u-overflowYAuto">
        <div class="o-home__inner u-container">
            <div v-if="!loading">
                <h2 class="u-colorSecondary">{{ $t('module.currentModules') }}</h2>
                <div v-if="currentModules.length > 0">
                    <ModuleBlock v-for="module in currentModules" :key="module.id" :module="module" />
                </div>
                <p v-else>{{ $t('module.noCurrentModules') }}</p>
            </div>
            <div class="u-grid">
                <Tile :title="$t('knowledgebase.knowledgebase')" href="/#/knowledgebase" class="-circlesOverlap" />
                <Tile :title="$t('news.news')" href="/#/news" class="-circles" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import api from '../services/api';
import { useI18n } from 'vue-i18n';

// Components
import ModuleBlock from '../components/molecules/ModuleBlock.vue';
import Tile from '../components/molecules/Tile.vue';

const { t } = useI18n();

const modules = ref([]);
const loading = ref(true);

const fetchModules = async () => {
    try {
        const response = await api.get('/linked-modules');

        if (response.status === 200 && Object.keys(response.data).length !== 0) {
            modules.value = Object.values(response.data).map(module => ({
                id: module.id,
                title: module.title,
                module_duration: module.module_duration,
                progress: module.progress,
                completed: module.completed,
                current_timestamp: module.current_timestamp,
                date_completed_by: module.date_completed_by,
                module_rating: module.module_rating
            }));
        }
        loading.value = false;
    } catch (error) {
        console.error('Error fetching modules:', error);
        loading.value = false;
    }
};

const currentModules = computed(() => modules.value.filter(module => !module.completed));

onMounted(() => {
    fetchModules();
});
</script>